import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_brick-by-brick-4/artifacts/chmsp3ov_card%20logo-01.JPG" 
                alt="Citiwide Construction Services" 
                className="h-14 w-auto object-contain bg-white rounded-lg p-2"
              />
            </Link>
            <p className="text-neutral-400 text-sm leading-relaxed">
              {companyInfo.overview}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 flex items-center gap-2">
              <span className="w-6 h-0.5 bg-red-600"></span>
              Quick Links
            </h4>
            <ul className="space-y-2">
              {['Home', 'About', 'Services', 'Projects', 'Contact'].map((link) => (
                <li key={link}>
                  <Link
                    to={link === 'Home' ? '/' : `/${link.toLowerCase()}`}
                    className="text-neutral-400 hover:text-red-500 transition-colors text-sm"
                  >
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4 flex items-center gap-2">
              <span className="w-6 h-0.5 bg-red-600"></span>
              Contact Us
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-center gap-2 text-neutral-400 hover:text-red-500 transition-colors text-sm"
                >
                  <Phone className="w-4 h-4 text-red-500" />
                  {companyInfo.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-2 text-neutral-400 hover:text-red-500 transition-colors text-sm"
                >
                  <Mail className="w-4 h-4 text-red-500" />
                  {companyInfo.email}
                </a>
              </li>
              <li>
                <div className="flex items-center gap-2 text-neutral-400 text-sm">
                  <MapPin className="w-4 h-4 text-red-500 flex-shrink-0" />
                  {companyInfo.address}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2">
            <p className="text-neutral-500 text-sm">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-neutral-500 hover:text-red-500 text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-neutral-500 hover:text-red-500 text-sm transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
